// The Listen / Whisper / Stop group shared by the monitor view and the coach's phone dock. Native buttons only (Tab,
// Enter and Space work everywhere); a disabled control points at the one sentence that explains why.
import type { CoachControls } from './coaching.ts';
import { CoachIcon } from './CoachIcons.tsx';
import type { CoachActionName } from './monitor.ts';

export function CoachControlGroup({ id, controls, busy, onAction }: { id: string; controls: CoachControls; busy: CoachActionName | null; onAction: (action: CoachActionName) => void }) {
  const why = `${id}-why`;
  const describe = (enabled: boolean) => (!enabled && controls.reason ? why : undefined);
  const stopWhy = `${id}-stop-why`;
  const stopHint = !controls.stop.enabled && !controls.reason;
  return (
    <div className="coach-controls">
      <div className="pair-actions" role="group" aria-label="Coaching">
        <button type="button" className="btn btn-control" aria-pressed={controls.listen.pressed} disabled={!controls.listen.enabled} aria-describedby={describe(controls.listen.enabled)} onClick={() => onAction('coach_listen')}>
          <CoachIcon name="listen" /> {busy === 'coach_listen' ? 'Listening…' : 'Listen'}
        </button>
        <button type="button" className="btn btn-control" aria-pressed={controls.whisper.pressed} disabled={!controls.whisper.enabled} aria-describedby={describe(controls.whisper.enabled)} onClick={() => onAction('coach_whisper')}>
          <CoachIcon name="whisper" /> {busy === 'coach_whisper' ? 'Whispering…' : 'Whisper'}
        </button>
        <button type="button" className="btn btn-end" disabled={!controls.stop.enabled} aria-describedby={stopHint ? stopWhy : describe(controls.stop.enabled)} onClick={() => onAction('coach_stop')}>
          <CoachIcon name="stop" /> {busy === 'coach_stop' ? 'Stopping…' : 'Stop coaching'}
        </button>
      </div>
      {controls.reason ? <p className="inline-reason" id={why}>{controls.reason}</p> : null}
      {stopHint ? <p className="field-hint" id={stopWhy}>Stop coaching is available once you are coaching this call.</p> : null}
      <p className="field-hint">Listen: you hear both sides and nobody hears you. Whisper: the agent hears you; the other party never does.</p>
    </div>
  );
}

export type CoachMessage = { tone: 'failed' | 'info'; text: string; requestId: string | null };
export function CoachMessageLine({ message }: { message: CoachMessage | null }) {
  if (!message) return null;
  return (
    <p className={`cmd-status cmd-${message.tone === 'failed' ? 'failed' : 'pending'}`} role={message.tone === 'failed' ? 'alert' : 'status'}>
      {message.text}
      {message.requestId ? <span className="ref"> Reference <span className="mono">{message.requestId}</span></span> : null}
    </p>
  );
}
